/**
 * What the corner label says and how much room it asks for - issue #83.
 *
 * Apart from BuildLabel.tsx because Layout needs the clearance too, and a
 * component file that also exports a constant cannot be hot-reloaded.
 */

import type { VersionInfo } from '../../schema'

/** Room the content and the sidebar leave at the bottom for the label, in theme spacing units. */
export const BUILD_LABEL_CLEARANCE = 4

/** The label's text, from what the server said: the release, then the commit or `dev`. */
export function buildLabelText(info: VersionInfo): string {
  return `${info.version} · ${info.commit ?? 'dev'}`
}
